<template>
  <div class="rich-editor">
    <div ref="toolbar" class="rich-editor-toolbar">
      <button type="button" class="ql-bold" title="加粗">B</button>
      <button type="button" class="ql-italic" title="斜体">I</button>
      <button type="button" class="ql-underline" title="下划线">U</button>
      <button type="button" class="ql-strike" title="删除线">S</button>
      <span class="toolbar-sep"></span>
      <button type="button" class="ql-header" value="1" title="标题1">H1</button>
      <button type="button" class="ql-header" value="2" title="标题2">H2</button>
      <span class="toolbar-sep"></span>
      <button type="button" class="ql-list" value="ordered" title="有序列表">OL</button>
      <button type="button" class="ql-list" value="bullet" title="无序列表">UL</button>
      <span class="toolbar-sep"></span>
      <button type="button" class="ql-color" value="red" title="红色"></button>
      <button type="button" class="ql-color" value="blue" title="蓝色"></button>
      <button type="button" class="ql-color" value="green" title="绿色"></button>
      <button type="button" class="ql-color" value="black" title="黑色"></button>
      <span class="toolbar-sep"></span>
      <button type="button" class="ql-clean" title="清除格式">🗑</button>
    </div>
    <div ref="editor" class="rich-editor-content"></div>
  </div>
</template>

<script>
import Quill from 'quill'
import 'quill/dist/quill.snow.css'

export default {
  name: 'RichEditor',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入内容...'
    }
  },
  data() {
    return {
      quill: null
    }
  },
  mounted() {
    this.quill = new Quill(this.$refs.editor, {
      theme: 'snow',
      placeholder: this.placeholder,
      modules: {
        toolbar: this.$refs.toolbar
      }
    })

    if (this.value) {
      this.quill.root.innerHTML = this.value
    }

    this.quill.on('text-change', () => {
      const html = this.quill.root.innerHTML
      this.$emit('input', html)
    })
  },
  watch: {
    value(newVal) {
      if (this.quill && newVal !== this.quill.root.innerHTML) {
        this.quill.root.innerHTML = newVal || ''
      }
    }
  },
  beforeDestroy() {
    if (this.quill) {
      this.quill = null
    }
  }
}
</script>

<style scoped>
.rich-editor {
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.rich-editor-toolbar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 10px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  flex-wrap: wrap;
}

.rich-editor-toolbar button {
  width: 30px;
  height: 30px;
  border: 1px solid transparent;
  background: #fff;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.rich-editor-toolbar button:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #0f172a;
}

.rich-editor-toolbar button.ql-active {
  background: #e0f2fe;
  border-color: #0ea5e9;
  color: #0369a1;
}

.toolbar-sep {
  width: 1px;
  height: 20px;
  background: #e2e8f0;
  margin: 0 4px;
}

.rich-editor-content {
  min-height: 120px;
  max-height: 220px;
  overflow-y: auto;
}

.rich-editor-content >>> .ql-editor {
  min-height: 120px;
  font-size: 14px;
  line-height: 1.7;
  color: #334155;
}

.rich-editor-content >>> .ql-editor.ql-blank::before {
  color: #94a3b8;
  font-style: normal;
}

.rich-editor-content >>> .ql-editor p {
  margin-bottom: 8px;
}

.rich-editor-content >>> .ql-editor ol,
.rich-editor-content >>> .ql-editor ul {
  padding-left: 20px;
  margin-bottom: 8px;
}

.rich-editor-content >>> .ql-editor h1 {
  font-size: 20px;
  font-weight: 600;
  margin: 12px 0 8px;
  color: #1e293b;
}

.rich-editor-content >>> .ql-editor h2 {
  font-size: 17px;
  font-weight: 600;
  margin: 10px 0 6px;
  color: #334155;
}
</style>
